import React from "react";
import Typography from "@material-ui/core/Typography";

const Subtitle2 = (props: any) => (
  <Typography variant="subtitle2" component="h6" gutterBottom {...props} />
);

export default Subtitle2;
